import { Component, inject, OnInit } from '@angular/core';
import { menuPermissions, organizationInfo, Session } from "../../../services/session.service";
import { ConnectionService } from "../../../services/connection.service";


@Component({
  selector: 'app-header-responsive',
  templateUrl: './header-responsive.component.html',
  styleUrl: './header-responsive.component.scss',
  standalone: false
})
export class HeaderResponsiveComponent implements OnInit {
  public currentUser;
  public organizationInfo:organizationInfo;
  public canShowMenu: menuPermissions;
  public online = true;
  isEvaluatorActingForAccreditor: boolean = false;
  isFaculty: boolean = false;

  private readonly session:Session = inject(Session);
  private readonly connectionService:ConnectionService = inject(ConnectionService);

  ngOnInit() {
    this.isEvaluatorActingForAccreditor = this.session.isEvaluatorWorkingForOtherInstitution();
    this.isFaculty = this.session.isFaculty();
    this.currentUser = this.session.getUser();
    this.canShowMenu = this.session.getPermissionToShow;
    this.session.getOrganizationInfo()
      .then((organizationInfo) => {
        this.organizationInfo = organizationInfo;
      });
    this.observeConnectionLost();
  }

  observeConnectionLost(){
    this.connectionService.offlineStatus.subscribe(() =>{
      this.online = false;
    });
    this.connectionService.onlineStatus.subscribe(() =>{
      this.online = true;
    })
  }

  showNoInternetModal(){
    this.connectionService.showNoInternetWarning();
  }
}
